import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
export const LoadMore = (props) => {
    const { loadingMore, moreIssuesCount, onClick } = props;
    const { t } = useTranslation();
    if (moreIssuesCount <= 0) {
        return null;
    }
    return _jsx("div", { className: 'flex-grow-1 text-right', children: _jsxs("button", { className: 'btn btn-link btn-sm', onClick: onClick, disabled: loadingMore, "data-testid": 'load-more-button', children: [loadingMore ? _jsx(Icon, { name: 'spinner', className: 'mr-2', spin: true, "data-testid": 'loading' }) : null, t('loadMoreCommonIssues'), " (", moreIssuesCount, ")"] }) });
};
